import React from "react";
import {RichTextEditor, RichTextEditorProps} from "@mantine/rte";
import {Typography, Box} from "@mui/material";

interface CustomRichTextEditorProps {
    title?: string;
    value?: string;
    onChange?: (value: string) => void;
    readOnly?: boolean;
    error?: string;
}

const CustomRichTextEditor: React.FC<CustomRichTextEditorProps & RichTextEditorProps> = ({
                                                                                             title,
                                                                                             value,
                                                                                             onChange,
                                                                                             readOnly = false,
                                                                                             error,
                                                                                             ...rest
                                                                                         }) => {
    return (
        <Box>
            {title && <Typography gutterBottom>{title}</Typography>}
            <RichTextEditor
                style={{border: error ? "1px solid red" : "1px solid #d9d9d9"}}
                {...rest}
                value={value ?? undefined}
                onChange={onChange ?? (() => {
                })}
                controls={[
                    ['bold', 'italic', 'underline', 'link'],
                    ['unorderedList', 'orderedList'],
                    ['alignLeft', 'alignCenter', 'alignRight'],
                ]}
                labels={{
                    save: 'Uložit',
                    remove: 'Smazat',
                    edit: 'Upravit',
                    bold: 'Tučné',
                    italic: 'Kurzíva',
                    underline: 'Podtržené',
                    strike: 'Přeškrtnuté',
                    link: 'Odkaz',
                    unorderedList: 'Neuspořádaný seznam',
                    orderedList: 'Uspořádaný seznam',
                    clean: 'Vyčistit',
                    video: 'Video',
                    alignCenter: 'Zarovnat na střed',
                    alignLeft: 'Zarovnat doleva',
                    alignRight: 'Zarovnat doprava',
                    image: 'Obrázek',
                    h1: 'Nadpis 1',
                    h2: 'Nadpis 2',
                    h3: 'Nadpis 3',
                    h4: 'Nadpis 4',
                    h5: 'Nadpis 5',
                    h6: 'Nadpis 6',
                    sub: 'Dolní index',
                    sup: 'Horní index',
                    code: 'Kód',
                    codeBlock: 'Blokový kód',
                    blockquote: 'Citace',
                }}
                readOnly={readOnly}
            />
            {error && (
                <Typography color="error" variant="body2">
                    {error}
                </Typography>
            )}
        </Box>
    );
};

export default CustomRichTextEditor;
